<!-- Points Summary -->
<div class="text-danger cursor-pointer" *ngIf="marketplaceItem$ | async">
  <fgb-points-summary-bar
    [backButtonLink]="marketplaceItemType.backLink"
    [marketplaceItemGroup]="marketplaceItemType.group"
  ></fgb-points-summary-bar>
</div>

<div class="container px-0">
  <ng-container>
    <div
      class="text-danger pt-3 cursor-pointer d-none d-lg-flex align-items-center"
      [routerLink]="[marketplaceItemType.backLink]"
    >
      <span class="material-icons align-middle fw-bold pe-2">keyboard_arrow_left</span>
      <span class="font-size-14 fw-bold"> {{ 'points.summary.bar.back.label' | translate }} </span>
    </div>
  </ng-container>

  <fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
</div>
